module.exports = __webpack_public_path__ + "static/media/hand-outline.43f6b955.svg";